import { stringify } from "query-string";
import { generateProofKey } from "../AuthenticatorHelpers/generateProofKey";
import { LoginDetailsParams, LoginDetailsResponse } from "./types";
import { getEnvironmentConfig } from "~/modules/config";
import { buildRegionalHost } from "~/utils/regionUtil";

export const getLoginDetails = (options: LoginDetailsParams): LoginDetailsResponse => {
    const environmentConfig = getEnvironmentConfig();
    const { region, regionNonFlex } = environmentConfig || {};
    const configRegion = regionNonFlex ?? region;
    const regionToUse = buildRegionalHost(configRegion ?? "");
    const twilioSSORedirectUrl = `https://flex${regionToUse}.twilio.com/callback`;
    const twilioSSOServiceUrl = `https://services${regionToUse}.twilio.com/v1/Flex/Authorize`;
    const twilioSSOAuthCallback = `https://services${regionToUse}.twilio.com/v1/Flex/Authentication/Callback`;

    const redirectUrlParam = options.redirectUrl ?? twilioSSORedirectUrl;
    const { nonce, codeChallenge, state, codeVerifier } = generateProofKey(options.clientId, redirectUrlParam);
    const queryParams = stringify(
        {
            isConsoleLogin: options.isConsoleLogin,
            redirectUrl: encodeURIComponent(options.redirectUrl ?? twilioSSOAuthCallback),
            nonce,
            codeChallenge,
            state,
            appType: options.appType,
            ssoProfileSid: !options.isConsoleLogin && options.ssoProfileSid,
            accountSid: options.isConsoleLogin ? options.accountSid : undefined,
            instanceSid: options.isConsoleLogin ? options.instanceSid : undefined
        },
        { encode: false, sort: false }
    );

    return { loginUrl: `${twilioSSOServiceUrl}?${queryParams}`, nonce, codeChallenge, state, codeVerifier };
};
